export default __webpack_public_path__ + "static/media/redBull2.a1c012e4.png";